import { Button } from "reactstrap";
import { navigateToCreateCustomer } from "./constants/ListingCustomerFunctions";
import { handleExportData } from "../Utils/ExportToCsv";
import SelectField from "../Utils/SelectField";
import { useSelector } from "react-redux";
import { TelcoHeaderForCustomer } from "./TelcoHeaderForCustomer";

export const CustomerTableCustomTableButtons = ({
  integerAndTextAttributes,
  toggleModal,
  setMessageForPopUp,
  setCustomerArray,
  table,
  // exportData,
  customerPermission,
  navigate,
  selectedCustomer,
  custId,
  dispatch,
  setLoading,
  setGetTable,
  setErrors,
  setErrorMessage,
  setErrorIcon,
  searchFields,
  setSearchFields,
  setRenderSimulate,
  stationPermission,
  reservationPermission,
  searchCustomerData,
  setCustId,
  setSearchExpanding,
}) => {
  const operatorConfiguration = useSelector(
    (state) =>
      state?.GetOperatorSpecificConfiguration?.OperatorSpecificConfiguration
  );
  const isEIPEnabled = operatorConfiguration?.configurations?.EIP?.value?.Enabled?.value === true;
  const buttonLabel = isEIPEnabled ? "Add Device" : "Add Customer";
  return (
    <div className="d-flex flex-column flex-lg-row flex-wrap w-100 justify-content-between align-items-center ps-2 py-2 gap-2">
      <div className="d-flex flex-row gap-2">
        <TelcoHeaderForCustomer
          custId={custId}
          dispatch={dispatch}
          setLoading={setLoading}
          setGetTable={setGetTable}
          customerPermission={customerPermission}
          setErrors={setErrors}
          setErrorMessage={setErrorMessage}
          setErrorIcon={setErrorIcon}
          integerAndTextAttributes={integerAndTextAttributes}
          searchFields={searchFields}
          setSearchFields={setSearchFields}
          setRenderSimulate={setRenderSimulate}
          stationPermission={stationPermission}
          reservationPermission={reservationPermission}
          searchCustomerData={searchCustomerData}
          setCustId={setCustId}
          setSearchExpanding={setSearchExpanding}
        />
      </div>
      <div className="d-flex flex-row gap-2">
        {/* {customerPermission && customerPermission?.has("export") &&
        <Button
          color="secondary"
          className="btn-label rv-secondary-btn rounded-1 px-1 ps-4 py-1 w-100 w-md-auto text-nowrap"
          onClick={() => {
            handleExportData(exportData);
          }}
        >
          <i className="ri-download-line label-icon secondary-label-icon align-middle fs-16 me-2"></i>
          <span className="px-2 ps-3 ms-2 me-1">Export</span>
        </Button>} */}
        {customerPermission &&
          customerPermission?.has("create") && (
            <Button
              color="secondary"
              className="btn-label rv-primary-btn rounded-1 px-1 ps-4 py-1 w-100 w-md-auto text-nowrap"
              onClick={() => navigateToCreateCustomer(navigate)}
            >
              <i className="ri-add-fill label-icon align-middle fs-16 me-1"></i>
              <span className="ps-2 ms-2 me-1">{buttonLabel}</span>
            </Button>
          )}
        {selectedCustomer?.length ? (
          <Button
            className="btn-label rv-primary-btn rounded-1 px-1 ps-4 py-1 w-100 w-md-auto text-nowrap"
            color="main-color"
            onClick={() => {
              const names = selectedCustomer.map((row) => row.CustomerId);
              let uniqueCustomers = Array.from(new Set(names));
              setCustomerArray(uniqueCustomers);
              setMessageForPopUp(
                `Are you sure you want to delete the selected items?`
              );
              toggleModal(selectedCustomer, "multi");
            }}
          >
            <i className="ri-close-fill label-icon align-middle fs-16 me-1"></i>
            <span className="ps-2 ms-2 me-1">Delete</span>
          </Button>
        ) : null}
      </div>
    </div>
  );
};
